export default "__VITE_ASSET__8ddJySN1__"